<script setup lang="ts">
  import { ref } from "vue";
  import ApplyForm from "~/components/h5/dls/entry-form/ApplyForm.vue";
  import ApplySuccess from "~/components/h5/dls/entry-form/ApplySuccess.vue";

  definePageMeta({
    layout: "h5-layout",
  });

  useHead({
    title: "得理律助-律师入驻",
    meta: [
      {
        name: "viewport",
        content: "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no",
      },
    ],
  });

  const step = ref(1);

  function onSuccess() {
    step.value = 2;
  }
</script>

<template>
  <div class="entry-form">
    <ApplyForm v-if="step === 1" @success="onSuccess" />
    <ApplySuccess v-else-if="step === 2" />
  </div>
</template>

<style lang="less" scoped>
  .entry-form {
    min-height: 100vh;
    background: linear-gradient(95deg, #82a5f3 0%, #5468ef 100%);
  }
</style>
